/* angular stuff */

/* 3rd party libraries */

/* our own stuff */
import { globalVariables } from 'src/app/core/constants/globalVariables';

// server url configuration
const url = {
    apiUrl: globalVariables.ERP_URL.gsApiUrl
};

// others
export const sharedConfig = {
    url: url,
};

